import { Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button';
import { useThemeStore } from '@/stores/theme';

export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  const Icon = theme === 'dark' ? Sun : Moon;

  return (
    <Button variant="ghost" size="icon" onClick={toggle} aria-label="Alternar tema">
      <Icon className="h-4 w-4" />
    </Button>
  );
}
